export default class GameStatus {
  constructor (data) {
    this.id = data.id

    this.upcoming = data.upcoming
    this.live = data.live
    this.ended = data.ended
    this.stopped = data.stopped

    this.name = data.nameFr
    this.shortname = data.shortnameFr
  }
}
